module.exports = __webpack_public_path__ + "img/samaggi.889d67fc.png";